<template>
  <div class="card mgt-20px" id="echeancierPaiement"
       v-if="!isEdit && factureDetail.montantTtc !== 0">
    <header class="header-card">
      <p>
        {{ $t('echeancierPaiement.echeancierPaiement')}}
      </p>
    </header>
    <div class="card-content">
      <div class="columns mgb-20px">
        <div
          class="column is-pulled-left"
          :class="factureDetail.nePasRelance ? 'is-3' : 'is-4'">
          {{ $t('echeancierPaiement.montantTotal')}}
          {{ montantNetAPayer | formatDevise}}
        </div>
        <div
          class="column has-text-centered"
          :class="factureDetail.nePasRelance ? 'is-3' : 'is-4'">
          {{ $t('echeancierPaiement.montantTotalPaye')}}
          {{ montantNetPaye | formatDevise }}
        </div>
        <div
          class="column columns"
          :class="factureDetail.nePasRelance ? 'is-3' : 'is-4'">
          <div v-if="factureDetail.nePasRelancer" class="column is-6" >
            {{ $t('echeancierPaiement.factureNonRelancable')}}
          </div>
          <div class="column">
            {{ $t('echeancierPaiement.montantResteAPayer')}}
            {{ montantNetAPayer - montantNetPaye | formatDevise }}
          </div>
        </div>
      </div>
      <echeancier-paiement :sens="factureDetail.sens"
                           :echeancierPaiement="facture.echeancierPaiement"/>
    </div>
  </div>
</template>

<script>

import echeancierPaiement from '@/components/devisCommandes/detailDevisCommande/echeancierPaiement';

export default {
  props: {
    facture: {
      type: Object,
      required: true,
    },
    factureDetail: {
      type: Object,
      required: true,
    },
    isEdit: {
      type: Boolean,
      required: false,
    },
  },
  components: {
    echeancierPaiement,
  },
  computed: {
    montantNetAPayer() {
      return this.facture.recapitulatifMontants.montantTtc
        - this.facture.recapitulatifMontants.montantAcomptesAffectes;
    },
    montantTotalAvoir() {
      let montantTotalAvoir = 0;
      this.factureDetail.avoirsAffectes.forEach((avoirAffecte) => {
        montantTotalAvoir += avoirAffecte.montantTtc;
      });
      return montantTotalAvoir;
    },
    montantNetPaye() {
      let montantPaye = 0;
      this.factureDetail.echeancierPaiement.forEach((echeance) => {
        if (echeance.montant >= 0) montantPaye += echeance.montant - echeance.resteALettrer;
        else montantPaye += echeance.montant + echeance.resteALettrer;
      });
      return montantPaye;
    },
  },
};

</script>
